<template>
  <MenuItem
    :route="route"
    :counter="counter"
    :is-badge-displayed="displayCounter && counter > 0"
    :is-badge-urgent="isBadgeUrgent"
  />
</template>
<script lang="ts">
import { computed, defineComponent, PropType } from "vue";

import { useInbox } from "@/components/inbox/useInbox";
import * as inject from "@/components/inject";
import MenuItem from "@/components/menu/MenuItem.vue";
import { MenuItem as MenuItemType } from "@/composables/useMenu";
import { useReleaser } from "@/ref";

export default defineComponent({
  components: { MenuItem },
  props: {
    route: { type: Object as PropType<MenuItemType>, required: true },
  },
  async setup() {
    const inboxFilter = inject.inboxFilter();
    const displayCounter = inject.inboxBadge();
    const releaser = useReleaser();
    const { counter, unarchivedNotices, unansweredMeetingsCount } = (
      await releaser.add(useInbox(inboxFilter))
    ).value;

    const unviewedUnarchivedNoticesCount = computed(
      () => unarchivedNotices.value?.filter((n) => !n.viewed).length ?? 0
    );

    const isBadgeUrgent = computed(
      () =>
        unviewedUnarchivedNoticesCount.value + unansweredMeetingsCount.value > 0
    );

    return { counter, displayCounter, isBadgeUrgent };
  },
});
</script>
